import {ChangeDetectionStrategy, Component, Input, OnDestroy} from '@angular/core';
import {BehaviorSubject, catchError, EMPTY, Observable, Subject, takeUntil} from "rxjs";
import {filter, map, take} from "rxjs/operators";
import {AssociationListResponse} from "@services/back-office/model/associationListResponse";
import {SharedService} from "@shared/shared.service";
import {AssociationsService} from "@shared/services/associations.service";
import {select, Store} from "@ngrx/store";
import * as selectFromLogin from "@login/ngrx/login.selectors";
import {Reducers} from "@app/reducers";
import {WebOwnProfileModel} from "@services/back-office/model/webOwnProfileModel";
import {UserInfoModel} from "@services/back-office/model/userInfoModel";
import {ListItemType} from '@shared/enum/list-item-type';

@Component({
    selector: 'app-global-search-component',
    templateUrl: './global-search-component.component.html',
    styleUrls: ['./global-search-component.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GlobalSearchComponentComponent implements OnDestroy {
  private destroyed$ = new Subject<void>();
  public loading$ = new BehaviorSubject('');
  currentUser$: Observable<WebOwnProfileModel | null>;
  currentUser: WebOwnProfileModel | null;

  @Input() searchResult: UserInfoModel | undefined;
  @Input() showCrmInfo: boolean;

  constructor(
      private sharedService: SharedService,
      private associationsService: AssociationsService,
      private store$: Store<Reducers>
  ) {
    this.currentUser$ = this.store$.pipe(select(selectFromLogin.selectCurrentUser));

    this.currentUser$.pipe(
        filter(data => !!data),
        take(1),
    ).subscribe((currentUser: WebOwnProfileModel | null) => {
      this.currentUser = currentUser;
    });
  }

  ngOnDestroy() {
    this.loading$.complete();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getAssociation(associationId?: string) {
    if (!associationId) {
      return;
    }
    this.loading$.next(associationId);
    this.associationsService.getAssociation(associationId).pipe(
        takeUntil(this.destroyed$),
        map((response: AssociationListResponse) => {
          if (response) {
            this.openCrmItem(ListItemType.ASSOCIATION, response.id!);
            this.loading$.next('');
          }
        }),
        catchError(() => {
          this.loading$.next('');
          return EMPTY;
        })
    ).subscribe();
  }

  openCrmItem(type: string, id: string) {
    this.sharedService.openCrmItem(type, id);
  }
}
